export const BlueCheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.50781 2.16699H13.4912C14.9084 2.16703 15.9792 2.58768 16.6943 3.30371C17.4094 4.01964 17.828 5.09014 17.8242 6.50684V13.4922C17.8242 14.9092 17.4037 15.9799 16.6875 16.6963C15.9711 17.4127 14.8997 17.834 13.4824 17.834H6.50781C5.09059 17.834 4.01905 17.4135 3.30273 16.6963C2.58637 15.979 2.16602 14.9051 2.16602 13.4834V6.50879C2.16602 5.09156 2.58636 4.02009 3.30273 3.30371C4.01911 2.58734 5.09058 2.16699 6.50781 2.16699ZM14.3359 6.84668C13.8991 6.41001 13.183 6.41001 12.7461 6.84668L8.81543 10.7764L7.25293 9.21387C6.816 8.77694 6.09904 8.77694 5.66211 9.21387C5.22566 9.65075 5.22557 10.3669 5.66211 10.8037L8.02051 13.1621C8.22987 13.3715 8.51563 13.4922 8.81641 13.4922C9.11704 13.4921 9.40205 13.3714 9.61133 13.1621L14.3418 8.43164C14.7676 7.99119 14.7761 7.28685 14.3359 6.84668Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  )
}
